/**
 * Export all constructs under the models namespace.
 */

export * from "@courses-models/user/src/ts/config/api";
